<template>
  <div>
    <div class="auto-height">
      <div class="card measure-side-header">
        <div class="card-body" style="padding-left:12px;">
          <h5 class="mb-0">
            {{ $t('maintenance.organizations.title') }}
          </h5>
          <span class="text-success cursor-pointer" v-if="selectedOrganization.id" @click="resetSelected">
            {{ $t('administration.users.create.reset_organization_label') }}
          </span>
        </div>
      </div>
      <OrganizationTreeFilterItem
          class="cursor-pointer"
          v-for="(child, index) in treeData.children"
          :item="child"
          :key="index"
          :level="1"
          :ids="ids"
          :expandedIds="expandedIds"
          :selectedOrganization="selectedOrganization"
          v-if="treeData.children && treeData.children.length"
          @updateSelected="updateSelected"
      ></OrganizationTreeFilterItem>
      <div v-if="!loading && ((treeData.children && !treeData.children.length) || !ids.length) && isMember()" class="p-3">
        {{ $t('administration.users.create.no_organizations_label') }}
      </div>
      <div v-if="!loading && ((treeData.children && !treeData.children.length)) && !isMember()" class="p-3">
        {{ $t('administration.users.create.no_organizations_label') }}
      </div>

      <div class="mt-5" v-if="loading">
        <div class="swing-container">
          <div class="swing">
            <div class="swing-l"></div>
            <div></div>
            <div></div>
            <div></div>
            <div class="swing-r"></div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import roleCheck from "@/util/ACL/roleCheck"

import OrganizationTreeFilterItem from '@/components/organizations/OrganizationTreeFilterItem.vue';

export default {
  name: 'OrganizationTreeFilter',
  data: function() {
    return {
      treeData: {
        name: this.$t('administration.users.create.organization_expand_label'),
        children: []
      },
      loading: true,
      ids: [],
      expandedIds: [],
      selectedOrganization: {}
    }
  },
  props: {
    organization: Object,
    organizationId: {}
  },
  watch: {
    getClient: function () {
      this.treeData = {
        name: this.$t('administration.users.create.organization_expand_label'),
        children: []
      }
      this.loadItems();
    },
    getSelectedOrganization: function (newValue, oldValue) {
      this.$emit('updatedCompany', newValue)
    }
  },
  components: {
    OrganizationTreeFilterItem
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getSelectedOrganization() {
      return this.selectedOrganization
    }
  },
  methods: {
    loadItems(setActive) {
      let self = this;
      this.loading = true;
      piincHttp.get('organizations', { params:
        {
          tree: 1,
          per_page: 100,
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.treeData = {
          name: self.$t('administration.users.create.organization_expand_label'),
          children: []
        }
        self.treeData.children.push(...response.data.items)
        self.loading = false;
      }, function() {});

      piincHttp.get('policies/organizations', { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.ids = response.data
      }, function() {});
    },
    isMember() {
      let member = false
      if (roleCheck('Member')) {
        member = true
      }
      return member
    },
    updateSelected(item) {
      if (item && item.id) {
        if (item.id != this.selectedOrganization.id) {
          this.selectedOrganization = item
        } else {
          this.selectedOrganization = {}
        }
      }
    },
    resetSelected() {
      this.selectedOrganization = {}
    }
  },
  created () {
    let self = this;
    if (this.getClient && this.getClient.slug) {
      this.loadItems()
    }
    if (this.organization && this.organization.id) {
      this.updateSelected(this.organization)
    }
    if (this.organizationId) {
      piincHttp.get('organizations', { params:
        {
          per_page: 100,
          client: this.getClient.slug
        }
      }).then(function(response) {
        let existingOrganization = _.find(response.data.items, function(object) {
          return object.id == self.organizationId
        });
        self.updateSelected(existingOrganization)
      }, function() {});
      piincHttp.get('organizations/' + this.organizationId + '/parent', { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.expandedIds = response.data
      }, function() {});
    }
  }
}
</script>
